import { render, staticRenderFns } from "./plan-preview.vue?vue&type=template&id=6c218400&scoped=true"
import script from "./plan-preview.vue?vue&type=script&lang=js"
export * from "./plan-preview.vue?vue&type=script&lang=js"
import style0 from "./plan-preview.vue?vue&type=style&index=0&id=6c218400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c218400",
  null
  
)

export default component.exports